<div class="overflow-x-auto table max-w-md min-w-max">
  <!-- <pre class="text-xs">{{ data | json }}</pre> -->
  <!-- <dx-tree-view [dataSource]="[data]" (onItemClick)="itemClick($event)" /> -->
  <dx-tree-list [dataSource]="data"
                keyExpr="id"
                #tree
                parentIdExpr="parentFamilyId"
                height="100%"
                class="focus-icons w-80"
                [expandedRowKeys]="['root']"
                [showColumnHeaders]="false"
                [showBorders]="false"
                [showRowLines]="false"
                [autoExpandAll]="false"
                (onContentReady)="treeListReady($event)"
                (onSelectionChanged)="selectionChanged($event)"
                (onRowRemoving)="rowRemoving($event)"
                (onCellPrepared)="cellPrepared($event)"
                (onRowClick)="onRowClick($event)"
  >
    <dxo-row-dragging [showDragIcons]="false"
                      [allowDropInsideItem]="true"
                      [allowReordering]="true"
                      [onReorder]="onReorder"
                      [onDragEnd]="onDragEnd"
                      [onDragStart]="onDragStart"
    />
    <dxo-scrolling mode="standard" />
    <dxo-selection mode="multiple"/>
    <dxo-editing [allowDeleting]="true" [allowAdding]="false" [allowUpdating]="false" mode="row"/>
    <dxi-column dataField="name" />
    <!-- <dxi-column cellTemplate="tpl">
      <div *dxTemplate="let row of 'tpl'">
        {{ row.data.id.substr(0 , 8) }}
      </div>
    </dxi-column> -->
    <dxi-column dataField="order" [visible]="false" sortOrder="asc"/>
    <dxi-column type="buttons">
      <dxi-button icon="add" [onClick]="rowAdd.bind(this)" />
      <dxi-button icon="edit" [onClick]="rowEdit.bind(this)" />
      <dxi-button name="delete" />
    </dxi-column>
  </dx-tree-list>
</div>
